module.exports = "<select data-topics-select multiple data-placeholder=\" \"></select>\n"